export enum ENotificationStyle {
  Default = 'default',
  Error = 'error',
}

export interface INotificationsState {
  text: string | null;
  style: ENotificationStyle;
}
